module.exports = __webpack_public_path__ + "img/pantalla-2-12.f5fa897e.png";